import { render, staticRenderFns } from "./prizeAction.vue?vue&type=template&id=859d7b52&"
import script from "./prizeAction.vue?vue&type=script&lang=js&"
export * from "./prizeAction.vue?vue&type=script&lang=js&"
import style0 from "./prizeAction.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports